import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { clear } from "@testing-library/user-event/dist/clear";

const EditConference = (props) => {
    const id = props.match.params.id;
    const history = useHistory();
    const [disabled, setdisabled] = useState(false);
    //const [isChecked, setChecked] = useState(false);
    const eventName = localStorage.getItem('eventname');
    const eventid = localStorage.getItem('eventid')
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedEndDate, setSelectedEndDate] = useState('');
    const [ConferenceCategory, setConferenceCategory] = useState('');
    const [conferenceCategoryData, setConferenceCategoryData] = useState([]);
    const [editConference , setEidtConference] = useState({
        event_name: eventName,
        conference_name: "",
        conference_day: "",
        conference_end_time: "",
        conference_amount: "",
        conference_discount_amount:"",
        conference_no_ofseats: "",
    });
    
    useEffect(() => {
        axios.get(`api/conference-category-index?id=${eventid}`).then(res => {
            if (res.status == 200) {
              const cCategoryData = res.data.conferenceCategories;
              setConferenceCategoryData(cCategoryData);
            }
            else {
                swal('Error', "Check API Something Wrong", 'error');
  
            }
  
  
        });
  
    }, []);
            
    useEffect(() => {
        axios.get(`api/conference-eidt/${id}`).then((res)=>{
          if(res.status == 200){
             const conferenceData = res.data.getconference;
            
             setEidtConference(conferenceData);
              setSelectedDate(conferenceData.conference_date);
              setSelectedEndDate(conferenceData.conference_end_date);
              setStartTime(conferenceData.conference_start_time);
              setEndTime(conferenceData.conference_end_time);
          }
        })
      }, [id]);
    
      //const [workShopCategoryID, setWorkShopCategoryID] = useState("");
    const conferenceCateId =  editConference.conference_category_id
    useEffect((e) => {
        setConferenceCategory(conferenceCateId);
    }, [conferenceCateId]);

    
    
    // const handleCheckboxChange = () => {
    //     setChecked(!isChecked);
    // };
  
    const handleInput = (e) => {
      e.persist();
      setEidtConference({ ...editConference, [e.target.name]: e.target.value });
    }
  
  console.log("editConference" ,editConference);
  
    const handleStartTime = (event) => {
      setStartTime(event.target.value);
    };
  
    const handleEndTime = (event) => {
      setEndTime(event.target.value);
    };
  
  
        
    const handleDateChange = (event) => {
      setSelectedDate(event.target.value);
    };
        
    const handleEndDateChange = (event) => {
      setSelectedEndDate(event.target.value);
    };
  
    const handleWorkShopCategory = (e) => {
      setConferenceCategory(e.target.value);
    }
  
    const submitWorkShop = (e) => {
  
      e.preventDefault();
  
      const data = {
        eventid,
        event_name: editConference.event_name,
        conference_name: editConference.conference_name,
        conference_day: editConference.conference_day,
        conference_amount: editConference.conference_amount,
        conference_discount_amount: editConference.conference_discount_amount,
        conference_doller_price: editConference.conference_doller_price,
        conference_aed_price: editConference.conference_aed_price,
        conference_no_of_seats: editConference.conference_no_ofseats,
        conference_start_time: startTime,
        conference_end_time: endTime,
        conference_date: selectedDate,
        conference_end_date: selectedEndDate,
        ConferenceCategory,

        // isChecked,
  
      }
     
    //   data.title == "" ? setdisabled(false) :
    //       data.descriptions == "" ? setdisabled(false) :
    //           setdisabled(true)

    console.log(data);
  
      axios.get('/sanctum/csrf-cookie').then(response => {
  
          axios.post(`/api/conference-update/${id}`, data).then(res => {
  
              if (res.data.status === 200) {
  
  
                  swal('Success', res.data.message, 'success');
  
                  history.push('/admin/conference/manage');
              }
              else {
  
                setEidtConference({ ...editConference, error_list: res.data.validate_error })
  
              }
  
          });
  
  
      });
  
  
    }

    let backGroundButtonByEvent = "";
    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);

    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
    }
    //backgroundColor: backGroundButtonByEvent,
    return (
  
      <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
        <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
          <h4 sx={{ m: 2, color: '#000000' }} >
            <Button sx={{
              float: 'right',
              marginTop: '2%',
              backgroundColor: backGroundButtonByEvent,
              ":hover": {
                color: "white"
              }
            }}
              color='success'
              size='small'
              variant='contained'
              onClick={() => history.goBack()}>
              Back
            </Button>
          </h4>
          <Card sx={{ width: '60vw', float: 'center' }} >
            <CardContent >
              <Typography component="h1" variant="h5">
                Update Conferecnce
              </Typography>
              <Box component="form" onSubmit={submitWorkShop} noValidate sx={{ mt: 3 }}>
                <Grid container spacing={4}>
                  <Grid item xs={6} >
                    <TextField
                      disabled
                      autoComplete="given-name"
                      required
                      fullWidth
                      label="Evnet Name"
                      autoFocus
                      name='event_name' onChange={handleInput}
                      defaultValue={eventName || ""}
                      />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">Conferecnce Category</InputLabel>
                      <Select
                       
                        value={ConferenceCategory || ""}
                        onChange={handleWorkShopCategory}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Workshop Category" >
                          {
                           conferenceCategoryData && conferenceCategoryData.map((val , index) => {
                            return(
                                  <MenuItem value={val.id} key={val.id}>{val.conference_category_title} </MenuItem>
                                    )})
                          }
                      
                    
  
                      </Select>
                     
                      <FormHelperText></FormHelperText>
                    </FormControl>
                  </Grid>
  
                 
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      label="Conference Name"
                      autoFocus
                      name='conference_name' onChange={handleInput}
                      value={editConference.conference_name || ""}/>
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      label="Conference Day"
                      autoFocus
                      name='conference_day' onChange={handleInput}
                      value={editConference.conference_day || ""} />
                  </Grid>
  
  
                  <Grid item xs={6} >
                    <TextField
                      id="date"
                      fullWidth
                      label="Conference Date"
                      type="date"
                      value={selectedDate}
                      onChange={handleDateChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      id="date"
                      fullWidth
                      label="Conference End Date"
                      type="date"
                      value={selectedEndDate}
                      onChange={handleEndDateChange}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      id="time"
                      label="Start Time"
                      type="time"
                      fullWidth
                      value={startTime}
                      onChange={handleStartTime}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 minutes interval
                      }} />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      id="time"
                      label="End Time"
                      type="time"
                      fullWidth
                      value={endTime}
                      onChange={handleEndTime}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 300, // 5 minutes interval
                      }} />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="Saudi Riyal Price"
                      autoFocus
                      name='conference_amount' onChange={handleInput}
                      value={editConference.conference_amount || ""} />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="Affiltion Price (USD)"
                      autoFocus
                      name='conference_discount_amount' onChange={handleInput}
                      value={editConference.conference_discount_amount || ""} />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="AED Price"
                      autoFocus
                      name='conference_aed_price' onChange={handleInput}
                      value={editConference.conference_aed_price || ""} />
                  </Grid>
                     <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="Doller Price"
                      autoFocus
                      name='conference_doller_price' onChange={handleInput}
                      value={editConference.conference_doller_price || ""} />
                  </Grid>
                  <Grid item xs={6} >
                    <TextField
                      autoComplete="given-name"
                      required
                      fullWidth
                      type="number"
                      label="No of seats"
                      autoFocus
                      name='conference_no_ofseats' onChange={handleInput}
                      value={editConference.conference_no_ofseats || ""}  />
                  </Grid>
  
  
                  {/* <Grid item xs={12} >
                                    <FormControlLabel required control={<Checkbox color="success" />}
                                        label=" Coupon"
                                        color="success"
                                        onChange={handleCheckboxChange} value="41" checked={isChecked} />
                                    <FormHelperText>Coupon is {isChecked ? ' Applied' : ' Not Applied'}.</FormHelperText>
                                </Grid> */}
  
  
  
  
  
                </Grid>
  
                <Grid container justifyContent="flex-end">
                  <Button
                    disabled={disabled}
                    type="submit"
                    // fullWidth
                    variant="contained"
                    sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                    Update Conferecnce
                  </Button>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </div>
  
    );
  }

export default EditConference;
